import React, { useState } from "react";
import { Container, Row, Col, Card, Form, Button, Alert } from "react-bootstrap";
import { APICall } from "../Utls/Api";

const SendNotification = () => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    recipient: "employee"
  });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", variant: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setAlert({ show: false, message: "", variant: "" });

    const endpoint = formData.recipient === "employee" 
      ? "/employee/sendNotificationToAll" 
      : "/employee/sendNotificationToSupervisor";

    try {
      const response = await APICall(endpoint, "POST", {
        title: formData.title,
        description: formData.description
      });
      
      setAlert({ 
        show: true, 
        message: "Notification sent successfully!", 
        variant: "success" 
      });
      setFormData({ title: "", description: "", recipient: "employee" });
    } catch (error) {
      setAlert({ 
        show: true, 
        message: error.response?.data?.message || "Failed to send notification", 
        variant: "danger" 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="p-4">
      <Row className="mb-4">
        <Col>
          <h2>Send Notification</h2>
        </Col>
      </Row>

      <Row>
        <Col lg={8} xl={6}>
          <Card>
            <Card.Body>
              {alert.show && (
                <Alert variant={alert.variant} onClose={() => setAlert({ ...alert, show: false })} dismissible>
                  {alert.message}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Recipient</Form.Label>
                  <Form.Select 
                    name="recipient" 
                    value={formData.recipient} 
                    onChange={handleChange}
                    required
                  >
                    <option value="employee">All Employees</option>
                    <option value="supervisor">All Supervisors</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    placeholder="Enter notification title"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Enter notification description"
                    required
                  />
                </Form.Group>

                <Button 
                  variant="primary" 
                  type="submit" 
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send Notification"}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SendNotification;
